import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
// Servicio para poa-techo y techo-financiador
@Injectable({
  providedIn: 'root'
})
export class PoaTechoService {
  token: string = '';
  baseUrl = environment.apiEndpoint;

  constructor(private http: HttpClient) {
    this.token = environment.token;
  }

  private header(accessToken: string) {
    var headers = new HttpHeaders({
      'Content-Type': 'application/json',
      "Accept": "application/json",
      "Authorization": "Bearer " + accessToken
    });
    return headers;
  }

  getPoaTecho(): Observable<any> {
    return this.http.get(this.baseUrl + 'poaTechos', { headers: this.header(this.token) });
  }

  getPoaTechoById(id: number): Observable<any> {
    return this.http.get(this.baseUrl + 'poaTecho/' + id, { headers: this.header(this.token) });
  }

  postPoaTecho(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.post(this.baseUrl + 'poaTecho', bodyString, { headers: this.header(this.token) });
  }

  putPoaTecho(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.put(this.baseUrl + 'poaTechoByGestionActual', bodyString, { headers: this.header(this.token) });
  }

  updateFuentePpto(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.put(this.baseUrl + 'updateFuentePpto', bodyString, { headers: this.header(this.token) });
  }

  deletePoaTecho(id: number): Observable<any> {
    return this.http.delete(this.baseUrl + 'poaTecho/' + id, { headers: this.header(this.token) });
  }

  getPoaTechoByGestion(estado: string, tipo_agregacion_id): Observable<any> {
    
    return this.http.get(this.baseUrl + 'poaTechoByGestionActual/' + estado + '/' + tipo_agregacion_id, { headers: this.header(this.token) });
  }

  // Seccion Techo Financieros
  getTechoFinanciador(): Observable<any> {
    return this.http.get(this.baseUrl + 'poaTechoFinanciadores', { headers: this.header(this.token) });
  }

  getTechoFinanciadorById(id: number): Observable<any> {
    return this.http.get(this.baseUrl + 'poaTechoFinanciador/' + id, { headers: this.header(this.token) });
  }

  postTechoFinanciador(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.post(this.baseUrl + 'poaTechoFinanciador', bodyString, { headers: this.header(this.token) });
  }

  putTechoFinanciador(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.put(this.baseUrl + 'poaTechoFinanciador', bodyString, { headers: this.header(this.token) });
  }

  deleteTechoFinanciador(id: number): Observable<any> {
    return this.http.delete(this.baseUrl + 'poaTechoFinanciador/' + id, { headers: this.header(this.token) });
  }

  postPoaTechoEstado(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.post(this.baseUrl + 'poaTechoSeguimiento', bodyString, { headers: this.header(this.token) });
  }

  getTipoAperturas(): Observable<any> {
    return this.http.get(this.baseUrl + 'tipoAperturas', { headers: this.header(this.token) });
  }

  postApertura(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.post(this.baseUrl + 'apertura', bodyString, { headers: this.header(this.token) });
  }


  getTipoAgregacion(): Observable<any> {
    return this.http.get(this.baseUrl + 'tipoAgregacion', { headers: this.header(this.token) });
  }
}
